import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import axios from 'axios'
import { setuserid, setRollNumber, setActiveExam } from '../Redux/Resultreducer';

export function attempts(result) {
    return result.filter(r => r !== undefined).length;
}

export function earnpoints(result, answers, queue, negativeMarking = 0) {
    let totalScore = 0;

    
    if (!result || !answers || !queue) return 0;

    for (let i = 0; i < queue.length; i++) {
        
        const userAnswer = result[i];
        const correctAnswer = answers[i];
        const questionPoints = queue[i]?.points || 1; 

        
        if (userAnswer !== undefined && userAnswer !== null) {
            if (userAnswer === correctAnswer) {
                
                totalScore += questionPoints;
            } else {
                
                totalScore -= negativeMarking;
            }
        }
    }
    return totalScore;
}

export function flagresult(totalPoints, earnPoints) {
    return (totalPoints * 33 / 100) <= earnPoints; 
}



export function CheckUserExist({ children }) {
    const auth = useSelector(state => state.result.userid);
    const dispatch = useDispatch();
    const [isChecking, setIsChecking] = useState(true);

    useEffect(() => {
        
        if (!auth) {
            const savedData = localStorage.getItem('quiz_auth_data');
            if (savedData) {
                try {
                    const { userid, rollNumber, activeExam } = JSON.parse(savedData);
                    if (userid) {
                        dispatch(setuserid(userid));
                        if (rollNumber) dispatch(setRollNumber(rollNumber));
                        if (activeExam) dispatch(setActiveExam(activeExam));
                    }
                } catch (err) {
                    console.error("Failed to restore auth", err);
                }
            }
        }
        setIsChecking(false);
    }, [auth, dispatch]);

    if (auth) return children;
    if (isChecking) return <div style={{ textAlign: 'center', marginTop: '50px' }}>Restoring session...</div>;

    return <Navigate to={'/'} replace={true}></Navigate>
}


export async function getServerData(url, callback) {
    const data = await (await axios.get(url))?.data;
    return callback ? callback(data) : data;
}



export async function postServerData(url, result, callback) {
    const data = await (await axios.post(url, result))?.data;
    return callback ? callback(data) : data;
}